export default __webpack_public_path__ + "static/media/televisa1.78a7cc34.png";